import React from 'react';
import {
  Document, Text, View, Image,
} from '@react-pdf/renderer';
import {
  Root, Title, Grid, Col, Box, Table, TableRow, TableCell, TableDataCell, Page,
} from '../../../components/pdf/Common';
import logo from '../../../asset/logo.png';
import syaban from '../../../asset/syaban.png';

const today = new Date();

export default function PurchaseOrderFile(props) {
  const { header, details } = props.data || {};
  return (
    <Document>
      <Page>
        <Root>
          <View style={{ justifyContent: 'flex-end', flexDirection: 'row' }}>
            <Image
              src={logo}
              style={{
                width: '25%',
              }}
            />
          </View>
          <View style={{ fontSize: '15px', flexDirection: 'row' }}>
            <Text style={{ textAlign: 'center', borderBottom: '1px solid #000', fontFamily: 'NotoSansJP-Bold' }}>{`${header.shopName}   御中`}</Text>
          </View>
          <View style={{ justifyContent: 'flex-end', flexDirection: 'row' }}>
            <Text style={{ textAlign: 'center' }}>{`発行日：${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日`}</Text>
          </View>
          <View style={{ justifyContent: 'flex-end', flexDirection: 'row' }}>
            <Text style={{ textAlign: 'center' }}>{`管理番号：${header.purchaseOrderNumber}`}</Text>
          </View>
          <Box style={{
            borderBottom: '3px double #000', marginTop: '15px', marginBottom: '15px', textAlign: 'center',
          }}
          >
            <Title>発注書</Title>
          </Box>
          <Grid>
            <Col flexBasis="65%">
              <Grid>
                <Col
                  flexBasis="20%"
                  style={{
                    alignItems: 'left', textAlign: 'left', justifyContent: 'left',
                  }}
                >
                  <View><Text>開催日時</Text></View>
                </Col>
                <Col
                  borderBottom
                  style={{
                    minWidth: '164px', wordWrap: 'break-word', maxWidth: '260px', paddingLeft: '3px',
                  }}
                >
                  <Text>{`${header.heldDate || ''} ${header.heldCharTime || ''}`}</Text>
                </Col>
              </Grid>
              <Grid style={{ marginTop: '2px' }}>
                <Col
                  flexBasis="20%"
                  style={{
                    alignItems: 'left', textAlign: 'left', justifyContent: 'left',
                  }}
                >
                  <View><Text>合計金額</Text></View>
                </Col>
                <Col
                  borderBottom
                  style={{
                    minWidth: '164px', wordWrap: 'break-word', maxWidth: '260px', paddingLeft: '3px',
                  }}
                >
                  <Text>{`¥${header.customerBillPrice}`}</Text>
                </Col>
              </Grid>
              <Grid style={{ marginTop: '2px' }}>
                <Col
                  flexBasis="20%"
                  style={{
                    alignItems: 'left', textAlign: 'left', justifyContent: 'left',
                  }}
                >
                  <View><Text>支払方法</Text></View>
                </Col>
                <Col
                  style={{
                    minWidth: '164px', wordWrap: 'break-word', maxWidth: '260px', paddingLeft: '3px',
                  }}
                  borderBottom
                >
                  <Text>{header.paymentMethodName}</Text>
                </Col>
              </Grid>
            </Col>
            <Col flexBasis="35%" style={{ alignItems: 'left', textAlign: 'left', justifyContent: 'left' }}>
              <Box style={{ position: 'relative' }}>
                <Text>ケータリングセレクション</Text>
                <Text>株式会社Cqree</Text>
                <Text>〒140-0013</Text>
                <Text>東京都品川区南大井6-16-16</Text>
                <Text>鈴中ビル大森4F</Text>
                <Text>TEL：0120-262-005</Text>
                <Text>登録番号：T3-0104-0111-4543</Text>
              </Box>
              <Image
                src={syaban}
                style={{
                  width: '30%', position: 'absolute', bottom: '5px', right: '-5px',
                }}
              />
            </Col>
          </Grid>
          <View style={{ marginTop: '5px' }}><Text>下記の通り御発注申し上げます。</Text></View>
          <Grid>
            <Col flexBasis="100%">
              <Table>
                <TableRow borderTop subTitle>
                  <Col flexBasis="20%">
                    <View
                      flexBasis="20%"
                      style={{
                        padding: 4,
                        textAlign: 'center',
                        backgroundColor: '#E7E6E6',
                      }}
                    >
                      <Text>注文番号</Text>
                    </View>
                  </Col>
                  <TableCell flexBasis="54.1%" style={{ borderLeft: '1 solid #000' }}><Text>商品名</Text></TableCell>
                  <TableCell flexBasis="21.5%"><Text>単価(税込)</Text></TableCell>
                  <TableCell flexBasis="11%"><Text>個数</Text></TableCell>
                  <TableCell flexBasis="22.7%"><Text>合計金額(税込)</Text></TableCell>
                  <TableCell flexBasis="9.7%"><Text>税区分</Text></TableCell>
                </TableRow>
                {details.map((item, index) => (
                  <TableRow key={item.id} style={{ borderBottom: 'none' }}>
                    <Col flexBasis="20%" style={{ borderBottom: `${details.length - 1 === index ? '1 solid #000' : 'none'}` }}>
                      <View
                        flexBasis="20%"
                        style={{
                          paddingLeft: '5px',
                          textAlign: 'left',
                          justifyContent: 'center',
                        }}
                      >
                        <Text>{index === 0 && header.orderNumber}</Text>
                      </View>
                    </Col>
                    <TableDataCell
                      flexBasis="54.1%"
                      style={{
                        paddingLeft: '5px',
                        flexWrap: 'wrap',
                        textAlign: 'left',
                        borderBottom: '1 solid #000',
                        borderLeft: '1 solid #000',
                      }}
                    >
                      <Text>{item.planName}</Text>
                    </TableDataCell>
                    <TableDataCell right flexBasis="21.5%" style={{ borderBottom: '1 solid #000' }}><Text>{item.unitPrice}</Text></TableDataCell>
                    <TableDataCell right flexBasis="11%" style={{ borderBottom: '1 solid #000' }}><Text>{item.quantity}</Text></TableDataCell>
                    <TableDataCell right flexBasis="22.7%" style={{ borderBottom: '1 solid #000' }}><Text>{item.totalPrice}</Text></TableDataCell>
                    <TableDataCell flexBasis="9.7%" style={{ borderBottom: '1 solid #000' }}><Text>{`${item.taxRate}%`}</Text></TableDataCell>
                  </TableRow>
                ))}
              </Table>
            </Col>
          </Grid>

          <View style={{ flexDirection: 'row' }}>
            <View style={{ flexBasis: '53.2%' }} />
            <View style={{
              flexBasis: '23.5%',
              backgroundColor: '#FFFFFF',
              padding: 4,
              textAlign: 'left',
              borderLeft: '1px solid #000',
              borderRight: '1px solid #000',
              borderBottom: '1px solid #000',
            }}
            >
              <Text>小計</Text>
            </View>
            <View style={{
              flexBasis: '16.3%',
              backgroundColor: '#E7E6E6',
              padding: 4,
              textAlign: 'right',
              borderRight: '1px solid #000',
              borderBottom: '1px solid #000',
            }}
            >
              <Text>{`¥${header.totalPrice}`}</Text>
            </View>
            <View style={{ flexBasis: '7%' }} />
          </View>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flexBasis: '53.2%' }} />
            <View style={{
              flexBasis: '23.5%',
              backgroundColor: '#FFFFFF',
              padding: 4,
              textAlign: 'left',
              borderLeft: '1px solid #000',
              borderRight: '1px solid #000',
              borderBottom: '1px solid #000',
            }}
            >
              <Text>割引金額</Text>
            </View>
            <View style={{
              flexBasis: '16.3%',
              backgroundColor: '#E7E6E6',
              padding: 4,
              textAlign: 'right',
              borderRight: '1px solid #000',
              borderBottom: '1px solid #000',
            }}
            >
              <Text>{`¥${header.discountPrice}`}</Text>
            </View>
            <View style={{ flexBasis: '7%' }} />
          </View>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flexBasis: '53.2%' }}>
              <Col borderBottom style={{ flexDirection: 'row', marginTop: 8 }}>
                <Col left style={{ flexBasis: '25%' }}><View><Text>⑧：消費税8%</Text></View></Col>
                <Col left style={{ flexBasis: '27%' }}><View><Text>対象合計金額</Text></View></Col>
                <Col right style={{ flexBasis: '18%' }}><View><Text>{header.eightPercentTotalPrice}</Text></View></Col>
                <Col style={{ flexBasis: '3%', marginRight: '5px' }}><View><Text>円</Text></View></Col>
                <Col left style={{ flexBasis: '15%' }}><View><Text>内消費税</Text></View></Col>
                <Col right style={{ flexBasis: '10%' }}><View><Text>{header.eightPercentTotalTaxPrice}</Text></View></Col>
                <Col style={{ flexBasis: '3%', marginRight: '3px' }}><View><Text>円</Text></View></Col>
              </Col>
              <Col borderBottom style={{ flexDirection: 'row', marginTop: 8 }}>
                <Col left style={{ flexBasis: '25%' }}><View><Text>⑩：消費税10%</Text></View></Col>
                <Col left style={{ flexBasis: '27%' }}><View><Text>対象合計金額</Text></View></Col>
                <Col right style={{ flexBasis: '18%' }}><View><Text>{header.tenPercentTotalPrice}</Text></View></Col>
                <Col style={{ flexBasis: '3%', marginRight: '5px' }}><View><Text>円</Text></View></Col>
                <Col left style={{ flexBasis: '15%' }}><View><Text>内消費税</Text></View></Col>
                <Col right style={{ flexBasis: '10%' }}><View><Text>{header.tenPercentTotalTaxPrice}</Text></View></Col>
                <Col style={{ flexBasis: '3%', marginRight: '3px' }}><View><Text>円</Text></View></Col>
              </Col>
            </View>
            <View style={{ flexBasis: '39.8%' }}>
              <View style={{ flexDirection: 'row' }}>
                <View style={{
                  flexBasis: '59%',
                  backgroundColor: '#FFFFFF',
                  padding: 4,
                  textAlign: 'left',
                  borderLeft: '1px solid #000',
                  borderRight: '1px solid #000',
                  borderBottom: '1px solid #000',
                }}
                >
                  <Text>ポイント利用額</Text>
                </View>
                <View style={{
                  flexBasis: '41%',
                  backgroundColor: '#E7E6E6',
                  padding: 4,
                  textAlign: 'right',
                  borderRight: '1px solid #000',
                  borderBottom: '1px solid #000',
                }}
                >
                  <Text>{`¥${header.usedPoint}`}</Text>
                </View>
              </View>
              <View style={{ flexDirection: 'row' }}>
                <View style={{
                  flexBasis: '59%',
                  backgroundColor: '#FFFFFF',
                  padding: 4,
                  textAlign: 'left',
                  borderLeft: '1px solid #000',
                  borderRight: '1px solid #000',
                  borderBottom: '1px solid #000',
                }}
                >
                  <Text>総合計金額（税込）</Text>
                </View>
                <View style={{
                  flexBasis: '41%',
                  backgroundColor: '#E7E6E6',
                  padding: 4,
                  textAlign: 'right',
                  borderRight: '1px solid #000',
                  borderBottom: '1px solid #000',
                }}
                >
                  <Text>{`¥${header.customerBillPrice}`}</Text>
                </View>
              </View>
            </View>
            <View style={{ flexBasis: '7%' }} />
          </View>
          <Box style={{ marginTop: '20px', marginBottom: '5px' }}>
            <View><Text>■開催日時：</Text></View>
            <Col
              borderTop
              borderRight
              borderBottom
              borderLeft
              style={{
                paddingLeft: '4px',
                justifyContent: 'center',
                minHeight: '20px',
                textAlign: 'left',
              }}
            >
              <Text>
                {`${header.heldDate || ''} ${header.heldCharTime || ''}`}
              </Text>
            </Col>
          </Box>
          <Box style={{ marginTop: '5px', marginBottom: '5px' }}>
            <View><Text>■注文者情報：</Text></View>
            <Col
              borderTop
              borderRight
              borderBottom
              borderLeft
              style={{
                paddingLeft: '4px',
                justifyContent: 'start',
                minHeight: '40px',
                textAlign: 'left',
              }}
            >
              <Text>
                {`${header.customerName}様   TEL:${header.customerPhone}   ※当日現地到着しましたら、こちらにご連絡ください`}
              </Text>
            </Col>
          </Box>
          <Box style={{ marginTop: '5px', marginBottom: '5px' }}>
            <View><Text>■納品先：</Text></View>
            <Col
              borderTop
              borderRight
              borderBottom
              borderLeft
              style={{
                paddingLeft: '4px',
                justifyContent: 'start',
                minHeight: '40px',
                textAlign: 'left',
              }}
            >
              <Text>
                {`${header.prefectureName || ''}${header.cityName || ''}${header.otherAddress || ''}`}
              </Text>
            </Col>
          </Box>
          <Box style={{ marginTop: '5px', marginBottom: '5px' }}>
            <View><Text>■商品内容備考：</Text></View>
            <Col
              borderTop
              borderRight
              borderBottom
              borderLeft
              style={{
                paddingLeft: '4px',
                justifyContent: 'start',
                minHeight: '90px',
                textAlign: 'left',
              }}
            >
              {header.productRemarks && header.productRemarks.split('\n').map((t, i) => <Text key={`${t} ${i + 1}`}>{t}</Text>)}
            </Col>
          </Box>
          <Box style={{ marginTop: '5px', marginBottom: '5px' }}>
            <View><Text>■お客様備考：</Text></View>
            <Col
              borderTop
              borderRight
              borderBottom
              borderLeft
              style={{
                paddingLeft: '4px',
                justifyContent: 'start',
                minHeight: '40px',
                textAlign: 'left',
              }}
            >
              {header.customerRemarks && header.customerRemarks.split('\n').map((t, i) => <Text key={`${t} ${i + 1}`}>{t}</Text>)}
            </Col>
          </Box>
          <Box style={{ marginTop: '5px', marginBottom: '5px' }}>
            <View><Text>■シークリー連絡事項：</Text></View>
            <Col
              borderTop
              borderRight
              borderBottom
              borderLeft
              style={{
                paddingLeft: '4px',
                justifyContent: 'start',
                minHeight: '80px',
                textAlign: 'left',
              }}
            >
              {header.shopRemarks && header.shopRemarks.split('\n').map((t, i) => <Text key={`${t} ${i + 1}`}>{t}</Text>)}
              {!header.repaid && <Text>{`${header.receiptAddress ? `【宛名】${header.receiptAddress}` : ''}${header.proviso ? ` 【但書き】${header.proviso}` : ''}`}</Text>}
              {!header.repaid && parseFloat(header.returnPrice.replace(/,/g, '')) > 0 && <Text>{`${header.returnPrice}円差額分は弊社から翌々月5日に貴店へ振り込みいたします。`}</Text>}
            </Col>
          </Box>
        </Root>
      </Page>
    </Document>
  );
}
